// Wrapper único de fetch para a API própria (Express :4000 via proxy /api).
// Cookie httpOnly: `credentials: 'include'` em TODA chamada.
const BASE_URL = '/api';

export class ApiError extends Error {
  status: number;
  body: unknown;

  constructor(status: number, body: unknown, message?: string) {
    const bodyMessage =
      body && typeof body === 'object' && 'error' in (body as Record<string, unknown>)
        ? String((body as Record<string, unknown>).error)
        : undefined;
    super(message ?? bodyMessage ?? `Erro na requisição (${status})`);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }

  get details(): Record<string, string[]> | undefined {
    if (this.body && typeof this.body === 'object' && 'details' in (this.body as Record<string, unknown>)) {
      const details = (this.body as Record<string, unknown>).details;
      return details && typeof details === 'object' ? (details as Record<string, string[]>) : undefined;
    }
    return undefined;
  }
}

type Json = Record<string, unknown>;

async function request<T>(method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE', path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  let data: Json | null = null;
  try {
    data = (await res.json()) as Json;
  } catch {
    // corpo vazio (ex.: 204) ou não-JSON — ok
  }

  if (!res.ok) {
    throw new ApiError(res.status, data);
  }

  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  del: <T>(path: string) => request<T>('DELETE', path),
  // multipart (upload de arquivo) — FormData NÃO deve receber Content-Type manual
  postForm: async <T>(path: string, form: FormData): Promise<T> => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    });

    let data: Json | null = null;
    try {
      data = (await res.json()) as Json;
    } catch {
      // corpo vazio — ok
    }

    if (!res.ok) {
      throw new ApiError(res.status, data);
    }

    return data as T;
  },
};